import * as React from "react";
const DownloadIcon = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21 21H3M18 11L12 17M12 17L6 11M12 17V3"
      strokeWidth={2.3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default DownloadIcon;
